import React from 'react';
import {get, startCase} from 'lodash';
import moment from 'moment';

const LogActionList = ({
  logs = [],
  action,
}) => {
  const formatValue = (value) => {
    if (value instanceof Array) {
      return value.join(', ')
    } else {
      return value
    }
  }

  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Log of {startCase(action)}</h2>
        </div>
      </div>

      <div className='Table' style={{gridTemplateColumns: '0.5fr 0.5fr 2fr 4fr 1.5fr'}}>
        {(() => {
          const columnHeaders = [
            'ID', 'Level', 'Action', 'Detail', 'Create at',
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <div
                  key={key}
                  className='Table__col Table__col--th'
                >
                  {header}
                </div>
              ))}
            </div>
          )
        })()}

        {logs.map((log, i) => (
          <div
            className='Table__row'
            key={i}
          >
            <div className='Table__col'>{get(log, 'id')}</div>
            <div className='Table__col'>{get(log, 'level')}</div>
            <div className='Table__col'>{get(log, 'action')}</div>
            <div className='Table__col'>
              {
                get(log, 'detail') && Object.entries(get(log, 'detail')).map(([key, value]) => {
                  return <div key={`${log.id}-${key}`}><strong>{key}</strong>: {formatValue(value)}</div>
                })
              }
            </div>

            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: log.createdAt !== null ?
                    moment(log.createdAt).format('YYYY-MM-DD HH:mm')
                  :
                    'N/A'
                }
              }
            />
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default LogActionList;
